// src/helpers/dateHelper.js

/**
 * Converts an ISO timestamp into a readable, human-friendly relative time.
 * Examples:
 *   - "Just now"
 *   - "5 minutes ago"
 *   - "2 hours ago"
 *   - "3 days ago"
 *   - "Oct 23, 2026"
 */
export const formatRelativeTime = (timestamp) => {
  if (!timestamp) return 'N/A';
  const now = new Date();
  const activityTime = new Date(timestamp);
  const diffMs = now - activityTime;
  const diffMins = Math.floor(diffMs / 60000);

  if (diffMins < 1) return 'Just now';
  if (diffMins < 60)
    return `${diffMins} minute${diffMins === 1 ? '' : 's'} ago`;
  const diffHours = Math.floor(diffMins / 60);
  if (diffHours < 24)
    return `${diffHours} hour${diffHours === 1 ? '' : 's'} ago`;
  const diffDays = Math.floor(diffHours / 24);
  if (diffDays < 7) return `${diffDays} day${diffDays === 1 ? '' : 's'} ago`;

  return activityTime.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};

/**
 * Converts a timestamp into a localized date & time string.
 * e.g., "Oct 23, 2026, 3:45 PM"
 */
export const formatDateTime = (timestamp) => {
  if (!timestamp) return 'N/A';
  const date = new Date(timestamp);
  return date.toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};
